import { Modal, Form } from "react-bootstrap";
import { Alphabet, At, FileText, Key, Send } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { HeaderText } from "./Controls/HeaderText";
import { Input } from "./Controls/Input";
import { Button } from "./Controls/Button";
import { Plan } from "./Data/ApiTypes";
import { Select } from "./Controls/Select";

export interface InviteParkerModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  submit: (data: InviteParkerForm) => void;
  plans?: any[];
}

export interface InviteParkerForm {
  name: string;
  phoneNumber: string;
  emailAddress: string;
  isLoginEnabled: boolean;
  planId: number;
}

export function InviteParkerModal({
  show,
  setShow,
  submit,
  plans
}: InviteParkerModalProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm<InviteParkerForm>({
    defaultValues: {
      name: "",
      emailAddress: "",
      phoneNumber: "",
      isLoginEnabled: false,
    },
  });
  const isLoginEnabledValue = watch("isLoginEnabled");
  function submitImpl(data: InviteParkerForm) {
    setShow(false);
    submit(data);
    reset();
  }

  return (
    <Modal centered show={show} onEscapeKeyDown={() => setShow(false)}>
      <form onSubmit={handleSubmit(submitImpl)}>
        <Modal.Header>
          <HeaderText>Add Parker</HeaderText>
        </Modal.Header>
        <Modal.Body>
          <div
            className="text-secondary gap-4 px-2 mb-4"
            style={{
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              alignItems: "center",
            }}
          >
            <Send size="32" className="text-primary" />{" "}
            <span>Invite someone to your plan to let them park!</span>
          </div>
          <div
            className="text-secondary gap-4 px-2 mb-3"
            style={{
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              alignItems: "center",
            }}
          >
            <Key size="32" className="text-primary" />{" "}
            <span>
              You can add or remove spots or access from them at any time
            </span>
          </div>
          {/* <div className="text-secondary gap-4 px-2 mb-0" style={{ display: "grid", gridTemplateColumns: "auto 1fr", alignItems: "center" }}>
                    <Trash2 size="32" className="text-primary" /> <span>Or put them entirely in the trash!</span>
                </div> */}
          <Input
            autoFocus
            type="text"
            label="Name"
            icon={<Alphabet className="fs-5" />}
            placeholder="Enter their Name"
            {...register("name", { required: "Name is required" })}
            error={errors.name}
          />
          <Form.Check
            type="switch"
            id="isLoginEnabled"
            label="Invite parker to manage their account?"
            {...register("isLoginEnabled")}
            className="mb-3"
          />
          {isLoginEnabledValue && (
            <Input
              type="email"
              label="E-mail Address"
              icon={<At className="fs-5" />}
              placeholder="Enter their Email address"
              {...register("emailAddress", {
                required: "Email Address is required",
              })}
              error={errors.emailAddress}
            />
          )}
          {plans && (
                <Select label="Plan"
                    {...register("planId", { valueAsNumber: true, required: "Plan is required" })}
                    >
                    {plans.map( plan => (
                        <option key={plan.id} value={plan.id}>
                            {plan.name}
                        </option>
                    ))}
                </Select>
          )}
          {/* <Input
                        type="tel"
                        label="Phone Number"
                        icon={<Telephone className="fs-5" />}
                        placeholder="###-###-####"
                        error={errors.phoneNumber}
                        {...register("phoneNumber", {
                            required: "Phone number is required",
                            pattern: {
                                value: /^\d{3}-\d{3}-\d{4}$/,
                                message: "Phone number must be in format ###-###-####"
                            }
                        })}
                    /> */}
        </Modal.Body>
        <Modal.Footer className="d-flex">
          <Button className="flex-grow-1" onClick={() => {setShow(false); reset(); }}>
            Cancel
          </Button>
          <Button className="flex-grow-1 btn-main" type="submit">
            Confirm
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
